/* eslint-disable react/jsx-key */
/* eslint-disable no-nested-ternary */
import React, { useState, Fragment, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import { toISTDate } from '@Apis/constants';
import {
  Table, Spin, Popconfirm, Drawer,
} from 'antd';
import {
  LoadingOutlined,
} from '@ant-design/icons';
import closeIcon from '@Images/icons/icon-close-blue.png';
import ExpenseActions from '@Actions/purchase/expense/expenseActions';
// import WorkFlowTimeLine from '../../../Common/WorkFlowTimeLine';
import LinkExpensePayment from './LinkExpensePayment';
import './style.scss';

/**
 *
 */
const ViewExpense = ({
  expenseById, user, selectedExpenseId,
  callback, unLinkExpenseLoading, getExpenseById,
  unLinkExpense, getExpenseByIdLoading, MONEY,
}) => {
  const [linkPaymentModal, setLinkPaymentModal] = useState(false);

  useEffect(() => {
    getExpenseById(user?.tenant_info?.tenant_id, selectedExpenseId);
  }, []);

  const selectedExpense = expenseById;

  const handleUnLinkPayment = (expensePaymentId) => {
    unLinkExpense(expensePaymentId, () => {
      getExpenseById(user?.tenant_info?.tenant_id, selectedExpenseId);
      callback();
    });
  };

  const columns = [
    {
      title: '',
      responsive: ['xs'],
      render: (item) => (
        <div className="mobile-list__item">
          <H3Text text={`PAYMENT ID - ${item?.payment_id}`} className="mobile-list__item-info" />
          <H3Text text={`UTR NUMBER: ${item?.utr_number}`} className="mobile-list__item-number" />
          <H3Text text={`LINKED AMOUNT - ${MONEY(item?.amount || 0)})`} className="mobile-list__item-info" />
        </div>
      ),
    },
    {
      title: 'PAYMENT ID',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      dataIndex: 'payment_id',
    },
    {
      title: 'UTR NUMBER',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => (
        <H3Text
          text={(
            <div>
              {`${record?.utr_number || '-'}`}
              <div className="" />
            </div>
          )}
          className="payment__po_no"
        />
      ),
    },
    {
      title: 'LINKED AMOUNT',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => MONEY(record?.amount || 0),
    },
    {
      title: '',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (record) => (
        <Fragment>
          {(!selectedExpense?.zoho_bill_payment_id && !selectedExpense?.tally_bill_payment_number) ? (
            <Popconfirm
              placement="topRight"
              title="Are you sure to unlink this payment?"
              onConfirm={() => handleUnLinkPayment(record?.expense_payment_id)}
              okText="Yes"
              cancelText="No"
            >
              <div className="expense-unlink-button">
                Unlink Payment
              </div>
            </Popconfirm>
          ) : <H3Text text="Payments imported from Tally/Zoho cannot be updated" />}
        </Fragment>
      ),
    },
  ];

  return (
    <Fragment>
      {getExpenseByIdLoading ? (
        <div className="view-expense__loader">
          <Spin />
        </div>
      ) : (
        <div className="view-expense__wrapper">
          <div className="ant-row">
            <div className="ant-col-md-24 ant-col-xs-24">
              <div className="view-expense__left">
                <div className="view-expense__header">
                  <div className="view-expense__header-left">
                    <div className="view-expense__header-field">
                      <H3Text
                        text="Expense Name"
                        className="view-expense__header-field-name"
                      />
                      <H3Text text={selectedExpense?.expense_title} className="view-expense__header-field-value" />
                    </div>

                    <div className="view-expense__header-field">
                      <H3Text
                        text="Expense Type"
                        className="view-expense__header-field-name"
                      />
                      <H3Text text={selectedExpense?.expense_type || '-'} className="view-expense__header-field-value" />
                    </div>

                    <div className="view-expense__header-field">
                      <H3Text
                        text="Department"
                        className="view-expense__header-field-name"
                      />
                      <H3Text text={selectedExpense?.department_name || '-'} className="view-expense__header-field-value" />
                    </div>

                    {selectedExpense?.amount && (
                      <div className="view-expense__header-field">
                        <H3Text
                          text="Payment Made"
                          className="view-expense__header-field-name"
                        />
                        <H3Text text={MONEY(selectedExpense?.amount || 0)} className="view-expense__header-field-value" />
                      </div>
                    )}
                    {selectedExpense?.expense_date && (
                      <div className="view-expense__header-field">
                        <H3Text text="Payment Date" className="view-expense__header-field-name" />
                        <H3Text
                          text={toISTDate(selectedExpense?.expense_date).format('DD/MM/YYYY hh:mm A')}
                          className="view-expense__header-field-value"
                        />
                      </div>
                    )}
                    {selectedExpense?.paid_through_account_id && (
                      <div className="view-expense__header-field">
                        <H3Text text="Payment Mode" className="view-expense__header-field-name" />
                        <H3Text text={selectedExpense?.paid_through_account_details?.account_name?.toProperCase()} className="view-expense__header-field-value" />
                      </div>
                    )}
                  </div>
                  <div className="view-expense__header-right">
                    <div className="action-buttons">
                      <H3Text
                        text={(
                          <div onClick={() => setLinkPaymentModal(true)}>
                            Link Payments
                          </div>
                        )}
                        className="action-button action-button-big"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <Table
                bordered
                showHeader
                title={() => `${selectedExpense?.expense_payments?.length || '0'} Linked Payment(s)`}
                size="small"
                columns={columns}
                dataSource={selectedExpense?.expense_payments || []}
                pagination={false}
                scroll={{ x: true }}
                loading={unLinkExpenseLoading}
              />

              <div className="expense-total__wrapper">
                {selectedExpense && (
                  <div className="expense-total_quote-totals">
                    <div className="expense-total_field">
                      <H3Text text="Total Payment" className="expense-total_field-name" />
                      <H3Text text={MONEY(selectedExpense?.grand_total || 0)} className="expense-total_field-value" />
                    </div>
                    <div className="expense-total_field">
                      <H3Text text="Used Amount" className="expense-total_field-name" />
                      <H3Text
                        text={MONEY((selectedExpense?.total_linked_amount) || '0')}
                        className="expense-total_field-value"
                      />
                    </div>
                    <div className="expense-total_field expense-total_field-total">
                      <H3Text text="Amount in Excess" className="expense-total_field-name" />
                      <H3Text
                        text={MONEY((selectedExpense?.grand_total + selectedExpense?.total_linked_amount) || 0)}
                        className="expense-total_field-value"
                      />
                    </div>
                  </div>
                )}
                {selectedExpense?.remarks && (
                  <div className="view__expense-tc">
                    <H3Text text="Remark" className="view__expense-tc-title" />
                    <H3Text text={selectedExpense?.remarks ? selectedExpense?.remarks : ''} className="view__expense-tc-body" />
                  </div>
                )}

              </div>
              {selectedExpense?.attachments?.length > 0 && (
                <div className="view-expense__attachments">
                  <H3Text text=" Attachment(s)" className="view-expense__attachments-field-name" />
                  {selectedExpense?.attachments?.map((attachment, index) => (
                    <div key={attachment} className="view-expense__attachments-field-value">
                      {' '}
                      <a href={attachment?.url} target="_blank" rel="noreferrer">{`Link #${index + 1}`}</a>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="ant-col-md-24 ant-col-xs-24">
            {/* <div className="view-expense__right" style={{ width: '330px' }}>
                  <div className="view-expense__timeline">
                    <WorkFlowTimeLine
                      workflowSteps={selectedExpense?.workflow_steps}
                      loading={updatePaymentOutgoingWorkflowLoading}
                      updateWorkflowStep={updatePaymentOutgoingWorkflow}
                      entityId={selectedExpense?.payment_id}
                      entityType="Payment"
                      callback={() => {
                        if (callback) callback();
                      }}
                    />
                  </div>
                </div> */}
          </div>
        </div>
      )}
      <Drawer
        open={linkPaymentModal}
        width="820px"
        onClose={() => setLinkPaymentModal(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '775px' }}>
            <H3Text text="Link Payment" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setLinkPaymentModal(false)} />
          </div>
        </div>
        <LinkExpensePayment
          selectedExpense={expenseById}
          callback={() => {
            setLinkPaymentModal(false);
            getExpenseById(user?.tenant_info?.tenant_id, selectedExpenseId);
            // getPaymentsOutgoingSuccess(null);
          }}
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, ExpenseReducers, TaxReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  unLinkExpenseLoading: ExpenseReducers.unLinkExpenseLoading,
  expenseById: ExpenseReducers.expenseById,
  getExpenseByIdLoading: ExpenseReducers.getExpenseByIdLoading,
});

const mapDispatchToProps = (dispatch) => ({
  unLinkExpense: (grnPaymentId, callback) => dispatch(ExpenseActions.unLinkExpense(grnPaymentId, callback)),
  getExpenseById: (tenantId, expenseId) => dispatch(ExpenseActions.getExpenseById(tenantId, expenseId)),
});

ViewExpense.propTypes = {
  expenseById: PropTypes.any,
  user: PropTypes.any,
  unLinkExpense: PropTypes.func,
  getExpenseByIdLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewExpense));
